import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCogs, faShieldVirus, faRoad, faTachometerAlt,
    faArrowRight, faMicrochip, faBolt, faSatellite
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './Financiacion.css';

// --- IMPORTACIÓN DE IMÁGENES ---
import subaruImgLocal from '../../images/subaru_outback.png';
import suzukiImgLocal from '../../images/jimmy.png';

// --- IMPORTACIÓN DE LOGOS (TÍTULOS) ---
import subaruLogo from '../../images/subaru-logo.png';
import suzukiLogo from '../../images/suzuki-logo.png';

export default function Financiacion() {
    const [marcaActiva, setMarcaActiva] = useState('subaru');

    const marcas = {
        subaru: {
            titulo: "SUBARU",
            logo: subaruLogo,
            sub: "CORE TECH",
            linea: "PERFORMANCE CORE",
            detalles: [
                { icon: faCogs, h: "BOXER ENGINE", p: "Centro de gravedad ultra-bajo." },
                { icon: faShieldVirus, h: "EYESIGHT V4", p: "Prevención de colisión por IA." },
                { icon: faRoad, h: "SYMMETRICAL AWD", p: "Tracción constante 25/25/25/25." }
            ],
            imagen: subaruImgLocal,
            id: "01"
        },
        suzuki: {
            titulo: "SUZUKI",
            logo: suzukiLogo,
            sub: "LITE TECH",
            linea: "ULTRA-LIGHT TECH",
            detalles: [
                { icon: faBolt, h: "BOOSTERJET", p: "Turbo-inyección de alta respuesta." },
                { icon: faMicrochip, h: "HEARTECT", p: "Plataforma de alta rigidez." },
                { icon: faTachometerAlt, h: "ALLGRIP PRO", p: "Reductora mecánica off-road." }
            ],
            imagen: suzukiImgLocal,
            id: "02"
        }
    };

    return (
        <section className='ido-dark-hud'>
            <style>
                {`
                .hud-main-core {
                    display: flex;
                    gap: 40px;
                }
                
                .title-logo-display {
                    height: 80px; /* Logo más grande en el título principal */
                    width: auto;
                    object-fit: contain;
                    margin-bottom: 10px;
                    filter: brightness(0) invert(1);
                }

                .nav-logo-img {
                    height: 50px; /* Tamaño maximizado en el selector */
                    width: auto;
                    object-fit: contain;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                    filter: opacity(0.3); /* Solo opacidad para que se vea el color original al activar */
                }

                .active .nav-logo-img {
                    filter: opacity(1);
                    transform: scale(1.15);
                }

                .nav-block {
                    border-bottom: 2px solid transparent;
                    padding-bottom: 10px;
                    transition: all 0.3s ease;
                }

                .nav-block.active {
                    border-bottom: 2px solid #ff0000;
                }

                @media (max-width: 991px) {
                    .hud-main-core {
                        flex-direction: column-reverse !important;
                    }
                    .hud-nav-system {
                        display: grid !important;
                        grid-template-columns: 1fr 1fr;
                        gap: 15px !important;
                    }
                    .nav-block {
                        padding: 10px !important;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .nav-logo-img {
                        height: 40px;
                    }
                    .title-logo-display {
                        height: 55px;
                    }
                    .hud-info-panel {
                        text-align: center;
                    }
                    .hud-specs-grid {
                        grid-template-columns: 1fr !important;
                    }
                    .spec-item {
                        justify-content: center;
                    }
                }
                `}
            </style>

            <div className="ido-binary-bg">1010101010101010</div>

            <div className='hud-container'>
                {/* SELECTOR SUPERIOR MAXIMIZADO */}
                <div className='hud-nav-system' style={{ display: 'flex', gap: '40px', marginBottom: '40px', justifyContent: 'center' }}>
                    {Object.keys(marcas).map((m) => (
                        <div
                            key={m}
                            className={`nav-block ${marcaActiva === m ? 'active' : ''}`}
                            onClick={() => setMarcaActiva(m)}
                            style={{ cursor: 'pointer' }}
                        >
                            <img src={marcas[m].logo} alt={marcas[m].titulo} className="nav-logo-img" />
                        </div>
                    ))}
                </div>

                <div className='hud-main-core'>
                    {/* COLUMNA DE DATOS */}
                    <div className='hud-info-panel' style={{ flex: 1 }}>

                        <p className="hud-subtitle" style={{ color: '#aaa', letterSpacing: '2px', marginBottom: '30px', fontWeight: 'bold' }}>
                            {marcas[marcaActiva].linea}
                        </p>

                        <div className='hud-specs-grid' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                            {marcas[marcaActiva].detalles.map((item, i) => (
                                <div key={i} className='hud-spec-item' style={{ display: 'flex', gap: '15px', background: 'rgba(255,255,255,0.03)', padding: '15px', borderRadius: '4px' }}>
                                    <div className='spec-icon-wrap' style={{ color: '#ff0000' }}>
                                        <FontAwesomeIcon icon={item.icon} size="lg" />
                                    </div>
                                    <div className='spec-content'>
                                        <h5 style={{ margin: 0, fontSize: '0.9rem', color: '#fff' }}>{item.h}</h5>
                                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#888' }}>{item.p}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <Link to={`/stock/autos`} className='ido-btn-red-hud' style={{ marginTop: '40px', display: 'inline-block', padding: '15px 30px', background: '#ff0000', color: '#fff', textDecoration: 'none', fontWeight: 'bold', borderRadius: '2px' }}>
                            ACCEDER AL STOCK <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '10px' }} />
                        </Link>
                    </div>

                    {/* COLUMNA VISUAL */}
                    <div className='hud-visual-panel' style={{ flex: 1 }}>
                        <div className='scanner-container' style={{ position: 'relative', border: '1px solid rgba(255,255,255,0.1)', padding: '20px', background: 'rgba(255,255,255,0.02)' }}>
                            <div className='corner tl'></div><div className='corner tr'></div>
                            <div className='corner bl'></div><div className='corner br'></div>

                            <img
                                key={marcaActiva}
                                src={marcas[marcaActiva].imagen}
                                alt={marcas[marcaActiva].titulo}
                                className='car-scan-img'
                                style={{ width: '100%', height: 'auto', display: 'block' }}
                            />
                            <div className='scan-effect'></div>
                        </div>
                        <div className="visual-footer" style={{ marginTop: '15px', fontSize: '0.7rem', display: 'flex', justifyContent: 'space-between', opacity: 0.5 }}>
                            <span>SISTEMA DE DIAGNÓSTICO V.2026</span>
                            <div className="bar-loader" style={{ width: '100px', height: '2px', background: '#333' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}